import { render, staticRenderFns } from "./VendorServices.vue?vue&type=template&id=1b27390e&scoped=true&"
import script from "./VendorServices.vue?vue&type=script&lang=js&"
export * from "./VendorServices.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1b27390e",
  null
  
)

export default component.exports